import gigateWireframeVideo from '../../../videos/Gigante_Wireframe.mkv';
import gigateBaseColorVideo from '../../../videos/Gigante_BaseColor.mkv';
import gigateFinalVideo from '../../../videos/Gigante_Final.mkv';
import gigateWireframeThumb from '../../../images/gigante-wireframe-thumb.png';
import gigateBaseColorThumb from '../../../images/gigante-basecolor-thumb.png';
import gigateFinalThumb from '../../../images/gigante-final-thumb.png';

import pistolWireframeVideo from '../../../videos/Pistol_Wireframe.mkv';
import pistolBaseColorVideo from '../../../videos/Pistol_BaseColor.mkv';
import pistolFinalVideo from '../../../videos/Pistol_Final.mkv';
import pistolWireframeThumb from '../../../images/pistol-wireframe-thumb.png';
import pistolBaseColorThumb from '../../../images/pistol-basecolor-thumb.png';
import pistolFinalThumb from '../../../images/pistol-final-thumb.png';

import smgWireframeVideo from '../../../videos/SMG_Wireframe.mkv';
import smgBaseColorVideo from '../../../videos/SMG_BaseColor.mkv';
import smgFinalVideo from '../../../videos/SMG_Final.mkv';
import smgWireframeThumb from '../../../images/smg-wireframe-thumb.png';
import smgBaseColorThumb from '../../../images/smg-basecolor-thumb.png';
import smgFinalThumb from '../../../images/smg-final-thumb.png';

// Content for the "3D Art & Animations" gallery modal. Each entry is rendered
// with the ProjectShowcase template (title, tools, thumbnail column + large
// preview). Add/remove entries here without touching the modal component.
// Each media item needs its own static `thumbnail` image (thumbnails never
// autoplay) plus a `src` asset (video/image/embed) shown when selected.
const artGalleryProjects = [
  {
    title: 'Windmill Island',
    type: 'sketchfab',
    previewThumbnail: 'https://media.sketchfab.com/models/4f02efac555a431e9a6e5004368c9271/thumbnails/722ba8ea3ff9444f8e0ffc357624aa6b/d64286c02c7e451fbacc723bc61de56f.jpeg',
    embedUrl: 'https://sketchfab.com/models/4f02efac555a431e9a6e5004368c9271/embed',
    modelUrl: 'https://sketchfab.com/3d-models/windmill-island-gorillaz-4f02efac555a431e9a6e5004368c9271',
    authorUrl: 'https://sketchfab.com/gfloresb09',
  },
  {
    title: 'The Iron Giant',
    tools: ['Maya','Substance Painter'],
    media: [
      { type: 'video', thumbnail: gigateWireframeThumb, src: gigateWireframeVideo, subtitle: 'Wireframe', playbackRate: 0.75 },
      { type: 'video', thumbnail: gigateBaseColorThumb, src: gigateBaseColorVideo, subtitle: 'BaseColor', playbackRate: 0.75 },
      { type: 'video', thumbnail: gigateFinalThumb, src: gigateFinalVideo, subtitle: 'Final', playbackRate: 0.75 },
    ],
  },
  {
    title: 'Prop Handgun',
    tools: ['Blender', 'Krita'],
    media: [
      { type: 'video', thumbnail: pistolWireframeThumb, src: pistolWireframeVideo, subtitle: 'Wireframe', playbackRate: 0.75 },
      { type: 'video', thumbnail: pistolBaseColorThumb, src: pistolBaseColorVideo, subtitle: 'BaseColor', playbackRate: 0.75 },
      { type: 'video', thumbnail: pistolFinalThumb, src: pistolFinalVideo, subtitle: 'Final', playbackRate: 0.75 },
    ],
  },
  {
    title: 'Prop SMG',
    tools: ['Blender', 'Krita'],
    media: [
      { type: 'video', thumbnail: smgWireframeThumb, src: smgWireframeVideo, subtitle: 'Wireframe', playbackRate: 0.75 },
      { type: 'video', thumbnail: smgBaseColorThumb, src: smgBaseColorVideo, subtitle: 'BaseColor', playbackRate: 0.75 },
      { type: 'video', thumbnail: smgFinalThumb, src: smgFinalVideo, subtitle: 'Final', playbackRate: 0.75 },
    ],
  },
];

export default artGalleryProjects;
